import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  SimpleWaitingRoomScreenComponent,
  MediaWaitingRoomScreenComponent,
} from '..'
import { onLiveCountdownZero as onLiveCountdownZeroAction } from '../../actions'

import './WebinarAudienceWaitingRoomComponent.scss'

const WebinarAudienceWaitingRoomComponent = (props) => {
  const {
    liveData,
    webinarTimeEpoch,
    isWebinarTimeInThePast,
    hasBeenBroadcasting,
    countdownEnabled,
    waitingRoomType,
    isWebinarOver,
    isMobileDevice,
    onLiveCountdownZero,
  } = props
  let content

  const commonWaitingRoomProps = {
    liveData,
    webinarTimeEpoch,
    isWebinarTimeInThePast,
    hasBeenBroadcasting,
    onLiveCountdownZero,
    countdownEnabled,
    isWebinarOver,
    isMobileDevice,
  }

  if (waitingRoomType === 'simple') {
    content = <SimpleWaitingRoomScreenComponent {...commonWaitingRoomProps} />
  } else {
    content = (
      <MediaWaitingRoomScreenComponent
        {...commonWaitingRoomProps}
        waitingRoomType={waitingRoomType}
      />
    )
  }

  return (
    <div className="webinar-audience-waiting-room-component">{content}</div>
  )
}

WebinarAudienceWaitingRoomComponent.propTypes = {
  liveData: PropTypes.object,
  webinarTimeEpoch: PropTypes.number,
  isWebinarTimeInThePast: PropTypes.bool,
  hasBeenBroadcasting: PropTypes.bool,
  countdownEnabled: PropTypes.bool,
  onLiveCountdownZero: PropTypes.func,
  waitingRoomType: PropTypes.oneOf(['simple', 'image', 'video']),
  isWebinarOver: PropTypes.bool,
  isMobileDevice: PropTypes.bool,
}

const mapStateToProps = (state) => ({
  webinarTimeEpoch: state.webinarAudienceRoom.webinarTimeEpoch,
  isWebinarTimeInThePast: state.webinarAudienceRoom.isWebinarTimeInThePast,
  hasBeenBroadcasting: state.webinarAudienceRoom.hasBeenBroadcasting,
  countdownEnabled: state.webinarAudienceRoom.countdownEnabled,
  waitingRoomType: state.webinarAudienceRoom.waitingRoomType,
  isWebinarOver: state.webinarAudienceRoom.isWebinarOver,
  isMobileDevice: state.webinarAudienceRoom.isMobileDevice,
})

export default connect(mapStateToProps, {
  onLiveCountdownZero: onLiveCountdownZeroAction,
})(WebinarAudienceWaitingRoomComponent)
